var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#53B7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8V6M6.75 4V6M6.75 6H8.75M6.75 6H4.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlue);
export default __webpack_public_path__ + "static/media/add_blue.52ec78b5925624cc951279a8950c0c82.svg";
export { ForwardRef as ReactComponent };